export default __webpack_public_path__ + "static/media/grafema_+-identity_06.6a6e474b.jpg";